module.exports = __webpack_public_path__ + "img/partnerships.e80e8b36.jpg";